import React from "react";
import classes from "./ModernArrows.module.scss";

const ARROW_COUNT = 5;

interface Props {
  side: "left" | "right";
}

export function ModernArrows({ side }: Props) {
  return (
    <div
      className={
        side === "right" ? classes.arrowStackFlipped : classes.arrowStack
      }
    >
      {Array.from({ length: ARROW_COUNT }, (_, i) => (
        <div
          key={ i }
          className={ `${classes.arrow} ${classes[`arrowColor${i + 1}`]}` }
        />
      ))}
    </div>
  );
}
